import * as React from 'react';
import { Label, Text, Pivot, PivotItem, Stack, TextField, StackItem, Icon, FontIcon, mergeStyles, useTheme, ActionButton, Link, IStyle, ILabelStyles, ProgressIndicator, SelectionMode, Toggle } from '@fluentui/react';
import { IUserContactInfo } from '../../../../Models/Admin/IUserContactInfo';
import { AttendeesList } from '../AttendeeList/AttendeesList';
import { InvoiceList } from '../../Invoices/InvoiceList/InvoiceList';
import { UserAttendeeRegistration } from './UserAttendeeRegistration';
import { IUserProfile } from '../../../../Models/Profile/IUserProfile';

interface IUserPropertiesViewProps {
    userContactInfo: IUserContactInfo;
    profile: IUserProfile;
    isLoading: boolean;
    editContactInfo: (id: string) => void
    editInvoiceInfo: (id: string) => void
    editUserRoles: (id: string) => void
    resetPassword: (id: string) => void;
    sendNewRegistrationEmail: (userId: string) => void;
    sendNewRegistrationEmailWithPassword: (userId: string) => void;
    changeUserState: (id: string, isActive: boolean) => void;
}


export const UserPropertiesView: React.FunctionComponent<IUserPropertiesViewProps> = (props) => {
    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });
    const mainLabelStyle = mergeStyles({ root: { fontSize: theme.fonts.mediumPlus.fontSize, fontWeight: 600 } });
    const labelStyle: ILabelStyles = { root: { color: theme.palette.greenDark } };
    

    return (
        <Stack >
            <Stack horizontal>
                <Stack horizontalAlign='end' styles={{ root: { width: 80 } }}>
                    <FontIcon iconName="AccountManagement" className={iconClass}  />
                </Stack>

                <Stack horizontal verticalAlign="center">
                    <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">
                        {props.userContactInfo.firstName}
                    </Text>
                    <Text styles={{ root: { fontWeight: 600, paddingLeft:5 } }} variant="xLarge"> {props.userContactInfo.lastName}</Text>
                    </Stack>
            </Stack>
            <Pivot styles={{ root: { paddingTop:20 } }}>
                <PivotItem
                    headerText="Obecné"
                    headerButtonProps={{
                        'data-order': 1,
                        'data-title': 'Obecné nastavení uživatele',
                    }}>
                    <Stack tokens={{ padding: 10 }}>
                        <Link onClick={() => props.resetPassword(props.userContactInfo.id)}>Resetovat heslo </Link>                        
                    </Stack>
                    <Stack styles={{ root: { height: 10 } }}>
                        {props.isLoading ? <ProgressIndicator /> : null}
                    </Stack>
                    <Stack tokens={{ padding: 10 }}>
                        <Toggle label="Aktivní uživatel" checked={props.userContactInfo.isActive} onChange={(e, check) => props.changeUserState(props.userContactInfo.id, check ? check:false) } />
                    </Stack>
                    <Stack tokens={{ padding:10, childrenGap: 8 }}>
                        <Label className={mainLabelStyle}>Kontaktní informace</Label>
                        <Stack>
                            <Label styles={labelStyle}>Email / Přihlašovací jméno</Label>
                            <Stack horizontal verticalAlign="center">
                            <Text>{props.userContactInfo.email}</Text>
                                {props.userContactInfo.emailConfirmed ?
                                    <Icon title="Email je ověřený" iconName="CheckMark" styles={{ root: { paddingLeft: 10, fontSize: 25, color: 'green' } }} /> :
                                <>
                                    <Icon title="Email není zatím ověřený"  iconName="Cancel" styles={{ root: { fontSize: 20, color: 'red', paddingLeft: 10, paddingRight: 10 } }} />
                                    
                                </>
                                }
                                </Stack>
                        </Stack>

                        <Stack>
                            <Label styles={labelStyle}>Jméno</Label>
                            <Text>{props.userContactInfo.firstName}</Text>
                        </Stack>
                        <Stack>
                            <Label styles={labelStyle}>Příjmení</Label>
                            <Text>{props.userContactInfo.lastName}</Text>
                        </Stack>                       
                        <Stack>
                            <Label styles={labelStyle}>Telefon</Label>
                            <Text>{props.userContactInfo.phoneNumber}</Text>
                        </Stack>
                        <Stack>
                            <Label styles={labelStyle}>Ulice</Label>
                            <Text>{props.userContactInfo.street}</Text>
                        </Stack>
                        <Stack>
                            <Label styles={labelStyle}>Město</Label>
                            <Text>{props.userContactInfo.city}</Text>
                        </Stack>
                        <Stack>
                            <Label styles={labelStyle}>PSČ</Label>
                            <Text>{props.userContactInfo.postalCode}</Text>
                        </Stack>
                        <Link onClick={() => props.editContactInfo(props.userContactInfo.id)}>Spravovat kontaktní informace </Link>
                        <Link onClick={() => props.editInvoiceInfo(props.userContactInfo.id)}>Spravovat fakturaní informace</Link>         
                        <Link onClick={() => props.editUserRoles(props.userContactInfo.id)}>Spravovat role</Link>         
                        <Link onClick={() => props.sendNewRegistrationEmail(props.userContactInfo.id)}>Odeslat registrační email</Link>         
                        <Link onClick={() => props.sendNewRegistrationEmailWithPassword(props.userContactInfo.id)}>Odeslat registrační email s nastavením hesla</Link>         
                    </Stack>
                </PivotItem>
                <PivotItem headerText="Účastníci">
                    <AttendeesList allowDelete={true} selectionMode={SelectionMode.single} userId={props.userContactInfo.id} city={props.userContactInfo.city} street={props.userContactInfo.street} postalCode={props.userContactInfo.postalCode}
                        email={props.userContactInfo.email}
                        phoneNumber={props.userContactInfo.phoneNumber} 
                    />
                </PivotItem>                
                <PivotItem headerText="Kurzy">
                    <UserAttendeeRegistration userId={props.userContactInfo.id} profile={props.profile } />
                </PivotItem>
                <PivotItem headerText="Vystavené faktury">
                    <InvoiceList filter={{ userId: props.userContactInfo.id }}  />
                </PivotItem>
               Kontakty
            </Pivot>
        </Stack>
    )
}